// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\ng[data-v-97c4374c], g *[data-v-97c4374c] {\n  pointer-events: none;\n}\ng.label[data-v-97c4374c] {\n  stroke-width: 2px;\n  stroke: \"#ccc\";\n  fill: rgba(10, 10, 10, 70%);\n}\n.label[data-v-97c4374c] {\n  stroke-width: 0;\n  fill: #ccc;\n  color: #ccc;\n  font-size: 18px;\n  font-weight: bold;\n}\n.value[data-v-97c4374c] {\n  stroke-width: 0;\n  fill: #aaa;\n  color: #aaa;\n  font-size: 14px;\n  font-weight: normal;\n}\n", ""]);
// Exports
module.exports = exports;
